const DEFAULT_FEATURES = {
  main: [
    { label: 'Posts', value: 'posts', enabled: true },
    { label: 'Events', value: 'events', enabled: true },
    { label: 'Announcements', value: 'announcements', enabled: true },
    { label: 'Polls', value: 'polls', enabled: true },
    { label: 'Bulletin', value: 'bulletin', enabled: true },
    { label: 'About', value: 'about', enabled: true },
    { label: 'Feedback', value: 'feedback', enabled: true },
    { label: 'Q&A Sessions', value: 'qaSessions', enabled: true },
  ],
  extra: [
    { label: 'Directory', value: 'directory', enabled: true },
    { label: 'Files', value: 'files', enabled: true },
    { label: 'Media', value: 'media', enabled: true },
    { label: 'Giving', value: 'giving', enabled: true },
  ],
}

const VALUE_ALIASES = {
  sessions: 'qaSessions',
}

const LABEL_BY_VALUE = {
  posts: 'Posts',
  events: 'Events',
  announcements: 'Announcements',
  polls: 'Polls',
  bulletin: 'Bulletin',
  about: 'About',
  feedback: 'Feedback',
  qaSessions: 'Q&A Sessions',
  directory: 'Directory',
  files: 'Files',
  media: 'Media',
  giving: 'Giving',
}

const TRANSLATION_KEY_BY_VALUE = {
  posts: 'navigation:drawer.posts',
  events: 'navigation:drawer.events',
  announcements: 'navigation:drawer.announcements',
  polls: 'navigation:drawer.polls',
  bulletin: 'navigation:drawer.bulletins',
  about: 'church:profile.about',
  feedback: 'navigation:drawer.memberFeedback',
  qaSessions: 'navigation:drawer.qaSessions',
  directory: 'navigation:drawer.directory',
  files: 'navigation:drawer.fileSharing',
  media: 'navigation:drawer.media',
  giving: 'giving:title',
}

export const normalizeFeatureItem = (item) => {
  if (!item?.value) return null
  const value = VALUE_ALIASES[item.value] || item.value

  return {
    ...item,
    value,
    label: LABEL_BY_VALUE[value] || item.label || value,
    enabled: typeof item.enabled === 'boolean' ? item.enabled : true,
  }
}

const normalizeGroup = (items, defaults) => {
  const normalizedItems = Array.isArray(items)
    ? items.map(normalizeFeatureItem).filter(Boolean)
    : []

  if (normalizedItems.length === 0) return defaults

  const seen = new Set()
  return normalizedItems.filter((item) => {
    if (seen.has(item.value)) return false
    seen.add(item.value)
    return true
  })
}

export const normalizeChurchFeatures = (features) => ({
  main: normalizeGroup(features?.main, DEFAULT_FEATURES.main),
  extra: normalizeGroup(features?.extra, DEFAULT_FEATURES.extra),
})

export const getEnabledChurchFeatures = (features) => {
  const normalized = normalizeChurchFeatures(features)
  return {
    main: normalized.main.filter((item) => item.enabled),
    extra: normalized.extra.filter((item) => item.enabled),
  }
}

export const getAllEnabledFeatureValues = (features) => {
  const enabled = getEnabledChurchFeatures(features)
  return new Set([...enabled.main, ...enabled.extra].map((item) => item.value))
}

export const isChurchFeatureEnabled = (features, value) => {
  if (value === 'none' || value === 'posts') return true
  const normalizedValue = VALUE_ALIASES[value] || value
  return getAllEnabledFeatureValues(features).has(normalizedValue)
}

export const getFeatureLabel = (item, translate) => {
  const normalized = normalizeFeatureItem(item)
  if (!normalized) return ''
  const key = TRANSLATION_KEY_BY_VALUE[normalized.value]
  return key ? translate(key) : normalized.label
}
